module.exports = __webpack_public_path__ + "img/no-logo.10f93dca.png";